// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import memoryStorageDriver from 'localforage-memoryStorageDriver';
/**
 * Ensure a localforage singleton has had the memory storage driver installed
 */
export async function ensureMemoryStorage(theLocalforage) {
    return await theLocalforage.defineDriver(memoryStorageDriver);
}
//# sourceMappingURL=memory.js.map